var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-popup',{staticClass:"popup",attrs:{"visible":_vm.show,"drag-enabled":true,"full-screen":_vm.fullscreen,"close-on-outside-click":false,"show-title":true,"onHidden":_vm.hide,"title":"Communicatie"}},[_c('dx-toolbar-item',{attrs:{"widget":"dxButton","location":"before","options":{
      onClick: function () {
        _vm.fullscreen = !_vm.fullscreen;
      },
      type: 'success',
      icon: _vm.fullscreen
        ? 'fas fa-compress-arrows-alt'
        : 'fas fa-expand-arrows-alt',
    }}}),_c('dx-scroll-view',[_c('div',[(_vm.project && _vm.project.id)?_c('ProjectCommunicationTable',{ref:"ProjectCommunicationTable",attrs:{"project":_vm.project}}):_vm._e()],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }